module.exports = __webpack_public_path__ + "media/images/dashboardimages/checklist-4b21ff4f832f9baa0a8f7afc27533ac5.svg";